var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { getGambler as getGamblerAction, updateProfile as updateProfileAction, checkPhone as checkPhoneAction, changePassword as changePasswordAction } from '../../actions/profile/creators/profile';
import { phoneConfirmation as phoneConfirmationAction, phoneConfirm as phoneConfirmAction } from '../../actions/creators/phoneConfirmation';
import ProfileForm from './ProfileForm';
import PhoneConfirmationModal from '../shared/PhoneConfirmationModal';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Loader from '../../components/Loader';
import moment from 'moment/moment';
import copyIcon from './../../assets/img/icons/copy.png';
import keyIcon from './../../assets/img/icons/key-icon.svg';
import { withRouter } from 'react-router';
import './../../assets/css/_profile.scss';
import ChangePasswordProfile from './ChangePasswordProfile';
import SuccessChangeProfile from './SuccessChangeProfile';
import { reduxForm } from "redux-form/immutable";
import classNames from 'classnames';
import { CLEAR_UPDATED_RESULT_PROFILE } from '../../actions/profile/profile';
var messages = defineMessages({
    profile_title: {
        id: "profile.title",
        defaultMessage: "Edit profile data"
    },
    profile_country: {
        id: "profile.country",
        defaultMessage: "Country"
    },
    profile_account_number: {
        id: "profile.account_number",
        defaultMessage: "Account number"
    },
    profile_login: {
        id: "profile.login",
        defaultMessage: "Login"
    },
    profile_name: {
        id: "profile.name",
        defaultMessage: "Name"
    },
    profile_surname: {
        id: "profile.surname",
        defaultMessage: "Surname"
    },
    profile_email: {
        id: "profile.email",
        defaultMessage: "E-mail"
    },
    profile_date: {
        id: "profile.date",
        defaultMessage: "Birth date"
    },
    profile_phone: {
        id: "profile.phone",
        defaultMessage: "Mobile phone"
    },
    profile_confirm_phone: {
        id: "profile.confirm_phone",
        defaultMessage: "Confirm phone"
    },
    profile_city: {
        id: "profile.city",
        defaultMessage: "City"
    },
    profile_new_pass: {
        id: "profile.new_pass",
        defaultMessage: "New password"
    },
    profile_confirm_pass: {
        id: "profile.confirm_pass",
        defaultMessage: "Confirm password"
    },
    profile_enter_pass: {
        id: "profile.enter_pass",
        defaultMessage: "Enter current password"
    },
    profile_save: {
        id: "profile.save",
        defaultMessage: "Save"
    },
    profile_header_accontId: {
        id: "profile.header_accontId",
        defaultMessage: "номер счета"
    },
    profile_change_password: {
        id: "profile.change_password",
        defaultMessage: "Изменить пароль"
    },
    profile_accountId_copied: {
        id: "profile.accountId_copied",
        defaultMessage: "номер счета скопирован в буфер обмена"
    },
    profile_minimum_symbols: {
        id: "profile.minimum_symbols",
        defaultMessage: " Минимум 6 символов, включая 1 цифру и 1 заглавную букву"
    },
    profile_change: {
        id: "profile.change",
        defaultMessage: "Изменить"
    },
    profile_password_not_same: {
        id: "profile.password_not_same",
        defaultMessage: "Пароли не совпадают"
    },
    profile_data_saved_success: {
        id: "profile.data_saved_success",
        defaultMessage: "Данные успешно сохранены"
    },
    profile_password_saved_success: {
        id: "profile.password_saved_success",
        defaultMessage: "Пароль успешно изменен"
    },
    profile_pointed_already: {
        id: "profile.pointed_already",
        defaultMessage: "Данный номер уже используется"
    },
    profile_pointed_email_already: {
        id: "profile.pointed_email",
        defaultMessage: "Данный e-mail уже используется"
    },
    profile_header_change_accontId: {
        id: "profile.header_change_accontId",
        defaultMessage: "Изменить пароль счета"
    }
});
var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showModal: false,
            loading: false,
            isCopied: false,
            isPasswordFiedls: false,
            isSuccessPasswordChange: false,
        };
        _this.onSubmit = function (values) {
            var Birthdate = values.Birthdate;
            var formattedBirthdate = moment(Birthdate, "DD-MM-YYYY").format('YYYY-MM-DD');
            values.Birthdate = formattedBirthdate;
            _this.props.updateProfileAction(values);
        };
        _this.changeProfilePassword = function (values) {
            _this.props.changePasswordAction(values);
        };
        _this.onPhoneConfirmation = function (values) {
            var gambler = _this.props.profile.gambler;
            var data = {};
            if (gambler.phone) {
                data['phone'] = gambler.phone.replace(/\D/gi, '');
            }
            _this.setState({
                showModal: true
            });
            _this.props.phoneConfirmationAction(data);
        };
        _this.onPhoneConfirm = function (submitEvent) {
            submitEvent.preventDefault();
            _this.setState({
                loading: true
            });
            _this.props.phoneConfirmAction({
                code: submitEvent.target.code.value.toUpperCase(),
            }).then(function () {
                _this.setState({
                    loading: false
                });
            });
        };
        _this.onCloseModal = function () {
            _this.setState({
                showModal: false
            });
        };
        _this.onCopyAccountNumber = function () {
            var user = _this.props.user;
            if (navigator.clipboard && user.accountNumber) {
                navigator.clipboard.writeText(user.accountNumber)
                    .then(function () {
                    console.log('Text copied to clipboard:', user.accountNumber);
                    _this.setState({
                        isCopied: true
                    });
                })
                    .catch(function (err) {
                    _this.timer = setTimeout(function () {
                        _this.setState({
                            isCopied: false
                        });
                    }, 2000);
                    console.error('Failed to copy text: ', err);
                }).finally(function () {
                    _this.timer = setTimeout(function () {
                        _this.setState({
                            isCopied: false
                        });
                    }, 2000);
                });
            }
            else {
                console.error('Clipboard API not supported or text is empty');
            }
        };
        _this.goToLastPath = function () {
            var history = _this.props.history;
            if (_this.state.isPasswordFiedls) {
                _this.setState({ isPasswordFiedls: false, isSuccessPasswordChange: false });
            }
            else
                history.push('/');
        };
        _this.showPasswordFiedls = function () { return _this.setState({ isPasswordFiedls: true }); };
        return _this;
    }
    // shouldComponentUpdate(nextProps, nextState) {
    //     return nextProps.profile !== this.props.profile || nextState.showModal !== this.state.showModal
    // }
    Profile.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.user !== this.props.user && this.props.authenticated) {
            this.props.getGamblerAction();
        }
        if (nextProps.profile.updateResult !== this.props.profile.updateResult && nextProps.profile.updateResult === 0) {
            this.setState({
                isSuccessPasswordChange: true
            });
            this.props.clearUpdatedResultAction();
        }
    };
    Profile.prototype.componentDidMount = function () {
        this.props.getGamblerAction();
    };
    Profile.prototype.componentWillUnmount = function () {
        if (this.timer)
            clearTimeout(this.timer);
    };
    Profile.prototype.render = function () {
        var _this = this;
        var _a = this.props, profile = _a.profile, user = _a.user, darkTheme = _a.darkTheme;
        var _b = this.state, showModal = _b.showModal, isCopied = _b.isCopied;
        var gambler = profile.gambler;
        if ((Object.keys(gambler).length === 0 && gambler.constructor === Object) && user.size === 0) {
            return false;
        }
        var props = {
            gambler: gambler,
            profile: profile,
            submitAction: this.onSubmit,
        };
        var propsPassowrdProps = {
            gambler: gambler,
            profile: profile,
            submitAction: this.changeProfilePassword,
        };
        var confirmSmsProps = {
            showModal: showModal,
            profile: profile,
            loading: this.state.loading,
            submitAction: this.onPhoneConfirm,
            close: this.onCloseModal,
        };
        var isEmpty = Object.keys(gambler).length === 0 && gambler.constructor === Object;
        if (!this.state.isPasswordFiedls && this.state.isSuccessPasswordChange) {
            return _jsx("div", __assign({ style: { padding: '40px' } }, { children: _jsx(SuccessChangeProfile, { clickOk: function () { return _this.goToLastPath(); }, message: this.props.intl.formatMessage(messages.profile_data_saved_success) }) }));
        }
        return (_jsxs("div", __assign({ id: "content" }, { children: [_jsx(Helmet, { children: _jsxs("title", { children: [window.COMPANY_NAME, " \u2014 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"] }) }), profile.fetching && _jsx(Loader, {}), _jsx("div", __assign({ className: "block blc_edit" }, { children: !isEmpty && (_jsxs("div", __assign({ id: "profile-form" }, { children: [_jsxs("div", __assign({ className: "new-join__head withdraw__head", style: { height: "initial", position: "relavtive" } }, { children: [_jsx("div", { onClick: this.goToLastPath, className: "new-join__back" }), _jsxs("span", __assign({ style: {
                                            lineHeight: "1.4em",
                                            height: "initial",
                                            padding: "10px 0px"
                                        } }, { children: [this.state.isPasswordFiedls ? _jsx(FormattedMessage, __assign({}, messages.profile_header_change_accontId)) : _jsx(FormattedMessage, __assign({}, messages.profile_header_accontId)), ":", _jsx("b", __assign({ style: { margin: "0 10px 0 5px", fontWeight: "900" } }, { children: user.accountNumber })), !this.state.isPasswordFiedls && (_jsx("span", __assign({ onClick: this.onCopyAccountNumber, style: { cursor: 'pointer' } }, { children: _jsx("img", { style: { marginBottom: -2 }, src: copyIcon, alt: "copy-icon" }) }))), isCopied ? (_jsxs("div", __assign({ style: { width: 150 }, className: "profile-alert-copy" }, { children: [_jsx("div", { className: "profile-alert-copy-block" }), _jsx("span", __assign({ style: { fontSize: 12 } }, { children: _jsx(FormattedMessage, __assign({}, messages.profile_accountId_copied)) }))] }))) : null] }))] })), _jsx("div", __assign({ className: "body", style: { padding: '18px 40px' } }, { children: this.state.isPasswordFiedls ? (_jsx(ChangePasswordProfile, __assign({}, propsPassowrdProps, { isSuccessPasswordChange: this.state.isSuccessPasswordChange, clickOk: this.goToLastPath }))) : (_jsxs(React.Fragment, { children: [_jsxs("button", __assign({ onClick: this.showPasswordFiedls, className: classNames(["change-password-button", { darkText: darkTheme }]) }, { children: [_jsx("img", { src: keyIcon, alt: "key-icon" }), _jsx(FormattedMessage, __assign({}, messages.profile_change_password))] })), _jsx(ProfileForm, __assign({}, props, { user: user }))] })) }))] }))) })), _jsx(PhoneConfirmationModal, __assign({}, confirmSmsProps))] })));
    };
    return Profile;
}(React.Component));
Profile.propTypes = {
    getGamblerAction: PropTypes.func.isRequired,
    updateProfileAction: PropTypes.func.isRequired,
    checkPhoneAction: PropTypes.func.isRequired,
    phoneConfirmationAction: PropTypes.func.isRequired,
    phoneConfirmAction: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};
var mapStateToProps = function (state) { return ({
    profile: state.application.get('profile'),
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    languageId: state.application.get('languageId'),
    darkTheme: state.application.get("darkTheme")
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getGamblerAction: getGamblerAction,
    updateProfileAction: updateProfileAction,
    checkPhoneAction: checkPhoneAction,
    phoneConfirmationAction: phoneConfirmationAction,
    phoneConfirmAction: phoneConfirmAction,
    changePasswordAction: changePasswordAction,
    clearUpdatedResultAction: function () { return dispatch({ type: CLEAR_UPDATED_RESULT_PROFILE }); }
}, dispatch); };
Profile = connect(mapStateToProps, mapDispatchToProps)(withRouter(Profile));
Profile = reduxForm({
    form: "profile-form"
})(Profile);
export default injectIntl(Profile);



// WEBPACK FOOTER //
// ./src/components/profile/Profile.jsx